import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

/**
 * Composable for internal chat Pro feature gating.
 *
 * The complete internal chat is controlled only by the account-local
 * `internal_chat_pro` feature. It has no external subscription dependency.
 */
export function useInternalChatPro() {
  const currentUser = useMapGetter('getCurrentUser');
  const currentRole = useMapGetter('getCurrentRole');
  const { isCloudFeatureEnabled } = useAccount();

  const proEnabled = computed(() =>
    isCloudFeatureEnabled('internal_chat_pro')
  );

  return {
    pollsEnabled: proEnabled,
    maxPrivateChannels: computed(() => (proEnabled.value ? null : 2)),
    searchHistoryDays: computed(() => (proEnabled.value ? null : 90)),
    isSuperAdmin: computed(() => currentUser.value?.type === 'SuperAdmin'),
    isAdmin: computed(() => currentRole.value === 'administrator'),
  };
}
